import ElementsCustom from "./Elements/elements_custom.json";
import Banner from "./Header/banner.json";
import Container from "./Header/container.json";
import Button from "./Input/button.json";
import Select from "./Input/select.json";
import Maintenance from "./Maintenance/maintenance.json";
import Info from "./Mobile/info.json";
import ProfileCard from "./Profile/profile_card.json";
import ProfileSidebar from "./Sidebars/profile_sidebar.json";
import MenuSidebar from "./Sidebars/menu_sidebar.json";
import CommentsSidebar from "./Sidebars/comments_sidebar.json";
import PopUp from "./Modals/popup.json";
import Copy from "./Modals/copy.json";
import Conditional from "./Modals/conditional.json";
import TitlesHtml from "./Website/titles_html.json";

export default {
    elements: {
        custom: ElementsCustom
    },
    header: {
        banner: Banner,
        container: Container
    },
    input: {
        button: Button,
        select: Select
    },
    maintenance: Maintenance,
    mobile: {
        info: Info
    },
    modals: {
        copy: Copy,
        popup: PopUp,
        conditional: Conditional
    },
    profile: {
        card: ProfileCard
    },
    sidebars: {
        profile: ProfileSidebar,
        menu: MenuSidebar,
        comments: CommentsSidebar
    },
    website: {
        titles_html: TitlesHtml
    }
}